// extracted by mini-css-extract-plugin
export default {"wrapper":"j6pXK","successWrapper":"N87eV","input":"KUPlA","button":"_4xmog","mobile":"Ok0O7","buttonAction":"dDcRk","buttonArrow":"zO6ph","skeleton-progress":"wXh4q"};